import React, { useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { previewDateFormat, UtcDateFormat } from "../formats";
import moment from "moment";
import { GuestIdentityApi } from "../../record-matching/api/guest-identity.api";

// subset of UseFiltersColumnProps<D> in react-table/index.d.ts
export interface CustomUseFiltersColumnProps {
  setFilter: (newFilterValue: FilterValue | null) => void;
  filterValue: FilterValue;
}

export interface FilterValue {
  type: "date" | "exact" | "lax";
  value: any;
}

export function PersonStatusSelectFilter({
  column: { filterValue, setFilter },
}: {
  column: CustomUseFiltersColumnProps;
}) {
  const options = useMemo(async () => GuestIdentityApi.getDistinctStatus(), []);

  return (
    <SelectComponent
      options={options}
      filterValue={filterValue?.value}
      setFilter={(value: string) =>
        value
          ? setFilter({
              value: value,
              type: "exact",
            })
          : setFilter(null)
      }
    />
  );
}

const SelectComponent: React.FC<{
  options: string[] | Promise<string[]>;
  filterValue: string;
  setFilter: (any: any) => void;
}> = ({ options, filterValue, setFilter }) => {
  const [realOptions, setRealOptions] = useState<string[]>([]);
  useEffect(() => {
    const wait = async () => {
      setRealOptions(await options);
    };
    wait();
  });

  return (
    <select
      value={filterValue || ""}
      onChange={(e) => setFilter(e.target.value)}
    >
      <option value="">All</option>
      {realOptions.map((option, i) => (
        <option key={i} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
};

export function DateFilter({
  column: { filterValue, setFilter },
}: {
  column: CustomUseFiltersColumnProps;
}) {
  const parsedToDat =
    filterValue && filterValue.value
      ? moment(filterValue.value, UtcDateFormat).toDate()
      : undefined;

  return (
    <DatePicker
      selected={parsedToDat}
      dateFormat={previewDateFormat}
      onChange={(date: Date) => {
        const dateObject = date && moment(date);
        if (dateObject && dateObject.isValid()) {
          setFilter({ value: dateObject.format(UtcDateFormat), type: "date" });
        } else {
          setFilter(null);
        }
      }}
      placeholderText={"DD/MM/YYYY"}
    />
  );
}
